const texteValeur = (valeur) => (typeof valeur === 'object' ? JSON.stringify(valeur) : valeur);

export function contenuErreurImport(erreur, t) {
  if (typeof erreur === 'string') return erreur;
  if (typeof erreur !== 'object' || erreur === null) return String(erreur);

  const numeroLigne = erreur.line || erreur.row;
  const prefixe = numeroLigne
    ? (t('importMappingModal.rowPrefix', { row: numeroLigne }) || `Ligne ${numeroLigne} : `)
    : '';

  if (erreur.errors && typeof erreur.errors === 'object') {
    return (
      <>
        {prefixe}
        {Object.entries(erreur.errors).map(([champ, message]) => (
          <span key={champ}><b>{champ}</b>: {texteValeur(message)} </span>
        ))}
      </>
    );
  }
  if (erreur.error) return <>{prefixe}{texteValeur(erreur.error)}</>;
  if (erreur.message) return <>{prefixe}{texteValeur(erreur.message)}</>;
  return <>{prefixe}{JSON.stringify(erreur)}</>;
}
